import { Card } from "PFComponents/card";
import { Divider } from "PFComponents/divider";
import React, { useEffect } from "react";
import { FormProvider, useForm, UseFormSetError } from "react-hook-form";

import { SkillsFrameworkData } from "../skills_frameworks.types";
import { CustomFieldsSection } from "./parts/custom_fields_section";
import { DescriptionSection } from "./parts/description_section";
import { Header } from "./parts/header";
import { SkillsSection } from "./parts/skills_section";
import css from "./skills_frameworks_edit_page.module.scss";

type SkillsFrameworksEditPageProps = {
  initialValues: SkillsFrameworkData;
  onSubmit: (values: SkillsFrameworkData, setError: UseFormSetError<SkillsFrameworkData>) => void;
};

export const SkillsFrameworksEditPage = ({
  initialValues,
  onSubmit
}: SkillsFrameworksEditPageProps): JSX.Element => {
  const formMethods = useForm<SkillsFrameworkData>({
    defaultValues: initialValues
  });
  const { handleSubmit, reset, setError } = formMethods;

  useEffect(() => {
    reset(initialValues);
  }, [initialValues, reset]);

  return (
    <FormProvider {...formMethods}>
      <form
        className={css.pageWrapper}
        onSubmit={handleSubmit((formValues) => {
          onSubmit(formValues, setError);
        })}
      >
        <Header />
        <Card className={css.card} paddingVariant="xl">
          <DescriptionSection />
          <Divider color="paletteNeutral0" theme={{ divider: css.divider }} />
          <CustomFieldsSection />
          <Divider color="paletteNeutral0" theme={{ divider: css.divider }} />
          <SkillsSection />
        </Card>
      </form>
    </FormProvider>
  );
};
